/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { connect } from "react-redux";
import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import man from "assets/images/man.png";
import homeBottomCurve from "assets/images/home-bottom-curve.svg";
import Logo from "assets/images/cuverd-logo-header.svg";
import FooterView from "components/FooterView";
import { AppleStoreButton, PlayStoreButton } from "components/PlayStoreButton";

const BottomContent = (props) => {
  const { organizationInfo, organizationLogo } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";
    const isShowAppStoreBand =
      organizationInfo?.organizationOptionJson?.showAppStoreBand?.toLowerCase() ===
      "y";

    return (
      <>
        {matches ? (
          <Grid container direction="column" alignItems="start" mt={"40px"}>
            <Grid item xs={12} ml={"24px"}>
              <Box mb={"24px"}>
                <Typography
                  variant="h1LatoBlack"
                  sx={{ lineHeight: "30px", fontSize: "28px" }}
                >
                  WE'LL ALWAYS <br /> HAVE YOU <br />
                  CUVERD <br />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} ml={"24px"}>
              <Typography
                variant="h3LatoSemiBold"
                sx={{ lineHeight: "26px", color: "#083d4c" }}
              >
                We are a company that believes in <br />
              </Typography>
            </Grid>
            <Grid item xs={12} ml={"24px"} my={"4px"}>
              <Typography
                variant="latoSemiBoldItalic"
                sx={{ fontSize: "28px" }}
              >
                TRANSPARENCY.
              </Typography>
            </Grid>
            <Grid item container ml={"24px"} xs={12} direction="row">
              <Grid item xs={6}>
                <Typography
                  variant="h3LatoSemiBold"
                  sx={{ lineHeight: "26px" }}
                >
                  We believe that you have the right to know exactly how much
                  your prescription will cost so there are never surprises when
                  you get to the pharmacy.
                </Typography>
                <br />
                <>
                  <Box mt={4} mb={1}>
                    <Typography
                      variant="h3LatoSemiBold"
                      sx={{
                        lineHeight: "26px",
                      }}
                    >
                      That's why we created
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "190px",
                      //backgroundColor: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                    }}
                  >
                    <img
                      src={organizationLogo?.logoBase64 || Logo}
                      alt="logo"
                      style={{ width: "190px" }}
                    />
                  </Box>
                </>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ width: "160px" }}>
                  <img
                    style={{ width: "100%", height: "100%" }}
                    src={man}
                    alt="man"
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={12}
              direction="column"
              alignItems="center"
              mt={2}
            >
              <Grid item xs={12}>
                <Box>
                  <Typography
                    variant="h3LatoBlack"
                    sx={{ letterSpacing: "0.84px" }}
                  >
                    DOWNLOAD THE APP
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ width: "327px" }} mt={"32px"} mb={"16px"}>
                  <AppleStoreButton storeBtnId="homeStoreBtn" />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ width: "327px" }} mb={"60px"}>
                  <PlayStoreButton storeBtnId="homeStoreBtn" />
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={12} justifyContent="center" sx={{ zIndex: 1 }}>
              <FooterView />
            </Grid>
          </Grid>
        ) : (
          <Grid container className="home-bottom-content">
            <Grid item xs={12} sm={4} sx={{ zIndex: 1 }}>
              <Box
                sx={{
                  marginLeft: "61px",
                  marginRight: "8px",
                  marginTop: "16px",
                }}
              >
                <img
                  style={{ width: "80%", height: "100%" }}
                  src={man}
                  alt="man"
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box sx={{ paddingBottom: "15px", paddingTop: "15px" }}>
                <Box mb={"29px"}>
                  <Typography variant="h1LatoBlack" sx={{ lineHeight: "40px" }}>
                    WE'LL ALWAYS <br /> HAVE YOU <br />
                    CUVERD <br />
                  </Typography>
                </Box>
                <Box sx={{ height: "106px" }} mb={"6px"}>
                  <Typography
                    variant="h2LatoSemiBold"
                    sx={{ lineHeight: "24px", color: "#083d4c" }}
                  >
                    We are a company that believes in <br />
                  </Typography>
                  <br />
                  <Typography variant="latoSemiBoldItalic">
                    TRANSPARENCY.
                  </Typography>
                </Box>
                <Box mb={2}>
                  <Typography
                    variant="h2LatoSemiBold"
                    sx={{ lineHeight: "26px" }}
                  >
                    We believe that you have the right to know exactly how much{" "}
                    <br />
                    your prescription will cost so there are never surprises
                    when
                    <br />
                    you get to the pharmacy.
                  </Typography>
                </Box>
                {isShowAppStoreBand && (
                  <>
                    <Box mb={1}>
                      <Typography
                        variant="h2LatoSemiBold"
                        sx={{ lineHeight: "26px" }}
                      >
                        That's why we created
                      </Typography>
                    </Box>
                    <Box
                      mb={"32px"}
                      sx={{
                        width: "190px",
                        //backgroundColor: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                      }}
                    >
                      <img
                        src={organizationLogo?.logoBase64 || Logo}
                        alt="logo"
                        style={{
                          width: "190px",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                    <Box mb={"10px"}>
                      <Typography
                        variant="h3LatoBlack"
                        sx={{ letterSpacing: "0.84px" }}
                      >
                        DOWNLOAD THE APP
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Box mr={"24px"} sx={{ zIndex: 1, height: "66px" }}>
                        <PlayStoreButton storeBtnId="homeStoreBtn" />
                      </Box>
                      <Box sx={{ zIndex: 1, height: "66px" }}>
                        <AppleStoreButton storeBtnId="homeStoreBtn" />
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
            <Grid item sm={12} justifyContent="center" sx={{ zIndex: 1 }}>
              {isShowBackgroundAssets && (
                <Box sx={{ marginBottom: "-4px" }}>
                  <img src={homeBottomCurve} alt="bottomarc" />
                </Box>
              )}
              <Box>
                <FooterView />
              </Box>
            </Grid>
          </Grid>
        )}
      </>
    );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
    organizationLogo: state.organizationLogo.data,
  };
};

export default connect(mapStateToProps)(BottomContent);
